/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_LabelInputs */

const en_audio_description_export_video_label = /** @type {(inputs: Audio_Description_Export_Video_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Video with AD`)
};

const fr_audio_description_export_video_label = /** @type {(inputs: Audio_Description_Export_Video_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter la vidéo avec AD`)
};

const de_audio_description_export_video_label = /** @type {(inputs: Audio_Description_Export_Video_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video mit Werbung exportieren`)
};

const it_audio_description_export_video_label = /** @type {(inputs: Audio_Description_Export_Video_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta video con AD`)
};

const ru_audio_description_export_video_label = /** @type {(inputs: Audio_Description_Export_Video_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт видео с рекламой`)
};

const es_audio_description_export_video_label = /** @type {(inputs: Audio_Description_Export_Video_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar vídeo con AD`)
};

const zh_cn2_audio_description_export_video_label = /** @type {(inputs: Audio_Description_Export_Video_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出带广告的视频`)
};

const ja_audio_description_export_video_label = /** @type {(inputs: Audio_Description_Export_Video_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADでビデオをエクスポート`)
};

const hi_audio_description_export_video_label = /** @type {(inputs: Audio_Description_Export_Video_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विज्ञापन के साथ वीडियो निर्यात करें`)
};

const pt_pt2_audio_description_export_video_label = /** @type {(inputs: Audio_Description_Export_Video_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar vídeo com anúncios`)
};

/**
* | output |
* | --- |
* | "Export Video with AD" |
*
* @param {Audio_Description_Export_Video_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_label = /** @type {((inputs?: Audio_Description_Export_Video_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_video_label(inputs)
	if (locale === "de") return de_audio_description_export_video_label(inputs)
	if (locale === "it") return it_audio_description_export_video_label(inputs)
	if (locale === "ru") return ru_audio_description_export_video_label(inputs)
	if (locale === "es") return es_audio_description_export_video_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_video_label(inputs)
	if (locale === "ja") return ja_audio_description_export_video_label(inputs)
	if (locale === "hi") return hi_audio_description_export_video_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_video_label(inputs)
	return en_audio_description_export_video_label(inputs)
});